import { RootState } from '../../store/reducers';

export const selectCurrentLead = (state: RootState): any => {
  return state.leadProfile;
};
